import { axiosClientAdmin } from '@/lib/auth';

export interface TestHostReachabilityRequest {
  uri: string;
  routeNamespaceId?: string;
  tenantId?: string;
  timeoutSeconds?: number;
}

export interface TestHostReachabilityResponse {
  isReachable: boolean;
  host: string;
  port: number;
  latencyMs: number;
  errorMessage?: string;
  usedEdgeLink: boolean;
  success: boolean;
  message?: string;
  code: number;
  untestableReason?: string;
}

export const testHostReachability = async (
  request: TestHostReachabilityRequest,
  signal?: AbortSignal
): Promise<TestHostReachabilityResponse> => {
  // Filter out empty strings - API expects null/undefined, not empty string
  const payload = {
    uri: request.uri,
    routeNamespaceId: request.routeNamespaceId || undefined,
    tenantId: request.tenantId || undefined,
    timeoutSeconds: request.timeoutSeconds,
  };

  const { data } = await axiosClientAdmin.post<TestHostReachabilityResponse>(
    '/Integration/Device/test-reachability',
    payload,
    { signal }
  );

  return data;
};
